/* ============================================================
   MOSAIK — SETUP POPUP (collection + dimensions)

   One popup gathers the whole starting setup: the tile collection AND
   the floor dimensions. There are no collection/dimension inputs left in
   the page menus — this popup replaces them (PC & mobile).

   Confirming writes `?collection=<slug>&w=<width>&h=<height>` to the URL.
   Loading the page WITH those params skips the popup and applies the setup
   directly (so a link can pre-fill everything).

   The engine still reads the hidden #mosaik-collection <select> and the
   hidden #mosaik-area-width / #mosaik-area-height inputs; this module sets
   their values and fires `change` on the <select> (same path as before).
   ============================================================ */
window.MosaikCollection = {

  param: 'collection',
  SLUGS:  { aero:'Polypropylene', industry:'PVC', ultra:'Ultra', xl:'XL', invisible:'Invisible' },
  LABELS: { Polypropylene:'Aero', PVC:'Industry', Ultra:'Ultra', XL:'XL', Invisible:'Invisible' },

  m: null, _hasChoice: false, _mandatory: false, _selected: null,

  $:function(id){ return document.getElementById(id); },
  keyToSlug:function(key){
    for(const s in this.SLUGS){ if(this.SLUGS[s] === key) return s; }
    return String(key).toLowerCase();
  },
  resolve:function(raw){
    if(!raw) return null;
    const v = String(raw).trim().toLowerCase();
    if(this.SLUGS[v]) return this.SLUGS[v];
    const key = Object.keys(this.LABELS).find(k => k.toLowerCase() === v);
    return key || null;
  },
  readParams:function(){
    try {
      const q = new URLSearchParams(window.location.search);
      const key = this.resolve(q.get(this.param));
      if(!key) return null;
      const w = parseFloat(q.get('w')), h = parseFloat(q.get('h'));
      return { key, w: (isFinite(w) && w > 0) ? w : null, h: (isFinite(h) && h > 0) ? h : null };
    } catch(e){ return null; }
  },

  setup:function(mosaik){
    this.m = mosaik; const self = this;
    this.buildChoices();

    const open = this.$('mosaik-setup-open');           if(open)  open.addEventListener('click', () => self.open(false));
    const modal = this.$('mosaik-collection-modal');    if(modal) modal.addEventListener('click', e => { if(e.target === modal && !self._mandatory) self.close(); });
    const close = this.$('mosaik-collection-modal-close'); if(close) close.addEventListener('click', () => { if(!self._mandatory) self.close(); });
    const val = this.$('mosaik-collection-validate');
    if(val){ val.innerText = mosaik.getText('Validate'); val.addEventListener('click', () => self.confirm()); }
    const title = this.$('mosaik-collection-modal-title'); if(title) title.innerText = mosaik.getText('Choose your setup');

    const sel = this.$('mosaik-collection');
    this._selected = sel ? sel.value : null;
    this.bindSideDims();
    this.setSummary(this._selected);

    // pre-filled via URL? apply and skip. Otherwise force the setup.
    const p = this.readParams();
    if(p && p.key){
      const cw = this.$('mosaik-area-width'), ch = this.$('mosaik-area-height');
      if(p.w && cw) cw.value = p.w;
      if(p.h && ch) ch.value = p.h;
      if(sel) sel.value = p.key;
      this._selected = p.key; this._hasChoice = true;
      if(sel) sel.dispatchEvent(new Event('change'));
      this.setSummary(p.key);
      if(window.MosaikStats) MosaikStats.setupApplied();
    } else if(window.MosaikMyTemplates && MosaikMyTemplates.readUrlTemplateId()){
      // ?template=<id> : une création enregistrée — la sienne, ou celle d'un
      // autre reçue par lien partagé — va être restaurée juste après
      // (MosaikMyTemplates.openFromUrl, différé pour passer après ce setup). Elle
      // porte sa propre collection ET ses propres dimensions, donc le popup n'a
      // rien à demander — et l'ouvrir ici ne ferait que réinitialiser le canvas
      // qu'on s'apprête à remplir. Condition sur le module et pas seulement sur
      // le paramètre : sans mosaik-mytemplates.js (save_templates_enabled à
      // false), un vieux lien ?template= ne doit pas escamoter la configuration.
      // openFromUrl rouvre le popup lui-même si l'id se révèle inutilisable.
    } else {
      this.open(true);
    }
  },

  buildChoices:function(){
    const grid = this.$('mosaik-collection-choices'), sel = this.$('mosaik-collection'), m = this.m, self = this;
    if(!grid || !sel) return;
    grid.innerHTML = '';
    Array.from(sel.options).forEach(opt => {
      const key = opt.value, col = m.collections[key];
      const card = document.createElement('button'); card.type = 'button'; card.className = 'mosaik-coll-card'; card.dataset.key = key;
      const thumb = document.createElement('span'); thumb.className = 'mosaik-coll-thumb';
      if(col && col.piles && col.piles[0]){
        // nuancier dédié (imgSelect) s'il existe, sinon l'image du canvas
        const thumbSrc = col.piles[0].imgSelect || col.piles[0].img;
        if(thumbSrc) thumb.style.backgroundImage = 'url("' + thumbSrc.replace(/"/g,'%22') + '")';
        else thumb.style.background = col.piles[0].color || '#ccc';
      } else { thumb.style.background = '#eee'; }
      const name = document.createElement('span'); name.className = 'mosaik-coll-name'; name.innerText = self.LABELS[key] || opt.text;
      // tile dimensions: translated, thickness on its own line (innerText turns \n into a <br>)
      const sub = document.createElement('span'); sub.className = 'mosaik-coll-sub'; sub.innerText = m.getText(opt.text).replace(' — ', '\n');
      card.appendChild(thumb); card.appendChild(name); card.appendChild(sub);
      card.addEventListener('click', () => self.select(key));
      grid.appendChild(card);
    });
  },

  select:function(key){
    this._selected = key;
    const grid = this.$('mosaik-collection-choices');
    if(grid) grid.querySelectorAll('.mosaik-coll-card').forEach(c => c.classList.toggle('sel', c.dataset.key === key));
  },

  open:function(mandatory){
    const modal = this.$('mosaik-collection-modal');
    if(!modal) return;
    // prefill the popup dimension inputs from the live values
    const cw = this.$('mosaik-area-width'), ch = this.$('mosaik-area-height');
    const dw = this.$('mosaik-dim-w'), dh = this.$('mosaik-dim-h');
    if(dw && cw) dw.value = cw.value;
    if(dh && ch) dh.value = ch.value;
    // highlight the current collection
    if(!this._selected){ const sel = this.$('mosaik-collection'); this._selected = sel ? sel.value : null; }
    this.select(this._selected);
    this._mandatory = !!mandatory && !this._hasChoice;
    const close = this.$('mosaik-collection-modal-close');
    if(close) close.style.display = this._mandatory ? 'none' : '';
    modal.style.display = 'block';
  },
  close:function(){ const modal = this.$('mosaik-collection-modal'); if(modal) modal.style.display = 'none'; },

  confirm:function(){
    const sel = this.$('mosaik-collection');
    const key = this._selected || (sel ? sel.value : null);
    if(!sel || !key || !this.m.collections[key]) return;
    const cw = this.$('mosaik-area-width'), ch = this.$('mosaik-area-height');
    const w = parseFloat((this.$('mosaik-dim-w') || {}).value), h = parseFloat((this.$('mosaik-dim-h') || {}).value);
    if(isFinite(w) && w > 0 && cw) cw.value = w;
    if(isFinite(h) && h > 0 && ch) ch.value = h;
    sel.value = key; this._hasChoice = true;
    // On ferme AVANT d'appliquer : le popup d'accueil n'a pas de croix tant qu'aucun
    // choix n'a été fait, donc si le redessin échouait le visiteur restait enfermé
    // devant un bouton qui semble mort. Le popup ne fait que renseigner les entrées
    // ci-dessus ; à partir d'ici son travail est terminé.
    this.close();
    sel.dispatchEvent(new Event('change'));    // full apply: reset + setCollection + draw (reads the new dims)
    this.setSummary(key);
    this.updateUrl(key, cw ? cw.value : '', ch ? ch.value : '');
    // after updateUrl so the recorded location.href is the shareable one
    if(window.MosaikStats) MosaikStats.setupApplied();
  },

  updateUrl:function(key, w, h){
    try {
      const url = new URL(window.location.href);
      url.searchParams.set(this.param, this.keyToSlug(key));
      if(w) url.searchParams.set('w', w);
      if(h) url.searchParams.set('h', h);
      history.replaceState(null, '', url.toString());
    } catch(e){ /* older browsers: ignore */ }
  },

  /* Format + épaisseur de la dalle, repris de l'<option> de la collection (donc
     traduit comme partout ailleurs). Le « — » de la chaîne devient un saut de
     ligne : format sur une ligne, épaisseur sur la suivante, comme sur les
     cartes du popup. */
  spec:function(key){
    const sel = this.$('mosaik-collection');
    const opt = sel ? Array.from(sel.options).find(o => o.value === key) : null;
    if(!opt || !this.m) return '';
    return this.m.getText(opt.text).replace(' — ', '\n');
  },

  /* Remplit la carte « Votre modèle » (nom + fiche de la dalle) et remet les
     champs de « Vos dimensions générales » sur les valeurs réellement en vigueur
     — c'est le point de synchronisation appelé après CHAQUE application d'un
     réglage : popup, paramètres d'URL, chargement d'un projet enregistré. */
  setSummary:function(key){
    const el = this.$('mosaik-setup-label');
    if(el){
      const label = (key && this.LABELS[key]) ? this.LABELS[key] : null;
      el.innerHTML = '';
      if(label){
        // la gamme est mise en capitales par le CSS, pas dans le texte : le
        // libellé reste lisible tel quel partout ailleurs (Aero, Ultra…)
        el.appendChild(document.createTextNode('Mosaik '));
        const name = document.createElement('span');
        name.className = 'mosaik-model-name';
        name.innerText = label;
        el.appendChild(name);
      } else el.appendChild(document.createTextNode(key || '—'));
    }
    const sub = this.$('mosaik-setup-sub');
    if(sub) sub.innerText = this.spec(key);
    this.syncSideDims();
  },

  /* Les champs de la barre latérale suivent les entrées canoniques cachées. */
  syncSideDims:function(){
    const cw = this.$('mosaik-area-width'), ch = this.$('mosaik-area-height');
    const sw = this.$('mosaik-side-wid'),   sl = this.$('mosaik-side-len');
    if(sw && cw) sw.value = cw.value;
    if(sl && ch) sl.value = ch.value;
  },

  /* Carte « Vos dimensions générales » : les deux champs ne sont qu'une façade.
     La valeur est recopiée dans l'entrée cachée correspondante, qui porte les
     écouteurs du moteur (mosaik-controller.js) — un changement de cote suit donc
     le MÊME chemin, qu'il vienne du popup, de l'URL ou d'ici.
     ↑ = longueur (#mosaik-area-height, la verticale du plan), → = largeur
     (#mosaik-area-width) : les flèches reprennent les axes des cotes dessinées
     autour du plan.
     On ne propage qu'une valeur exploitable : pendant la frappe le champ passe
     par « », « 8. »… et redessiner sur un NaN viderait le plan. */
  bindSideDims:function(){
    const self = this;
    [['mosaik-side-wid', 'mosaik-area-width'], ['mosaik-side-len', 'mosaik-area-height']].forEach(pair => {
      const src = self.$(pair[0]), dst = self.$(pair[1]);
      if(!src || !dst) return;
      ['change','keyup'].forEach(ev => src.addEventListener(ev, () => {
        const v = parseFloat(src.value);
        if(!isFinite(v) || v <= 0) return;
        if(v === parseFloat(dst.value)) return;              // rien de neuf : pas de redessin
        dst.value = v;
        dst.dispatchEvent(new Event('change'));              // reset + redraw (contrôleur)
        const sel = self.$('mosaik-collection');
        const cw = self.$('mosaik-area-width'), ch = self.$('mosaik-area-height');
        self.updateUrl(sel ? sel.value : self._selected, cw ? cw.value : '', ch ? ch.value : '');
      }));
    });
  }
};
